var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import { assign, first, last, toPairs } from 'lodash';

import algoliasearch from 'algoliasearch';

export var algolia = function () {
  function algolia(ID, KEY) {
    _classCallCheck(this, algolia);

    this.client = algoliasearch(ID, KEY);
  }

  /**
   * Send a search request with text criteria, latitude, longitude
   * and optional radius
   *
   * @param {string} criteria
   * @param {object} geo
   * @returns {Promise} promise with resolved content or error
   * @example
   * var search = new algolia();
   * var result = algolia.geoSearch('something', { latitude: 34, longitude: 77, radius: 20000 });
   */
  algolia.prototype.geoSearch = function geoSearch(criteria, options) {
    var _this = this;

    if (!criteria) criteria = '';

    var search = {
      query: criteria
    };

    return new Promise(function (resolve, reject) {
      _this.index.search(assign(search, options), function (err, content) {
        if (err) return reject(err);
        return resolve(content);
      });
    });
  };

  algolia.prototype.merchantIdsSearch = function merchantIdsSearch(criteria, options) {
    var _this2 = this;

    var field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'vendor.id';

    if (!criteria) criteria = '';

    return new Promise(function (resolve, reject) {
      if (!options) return reject('No merchant ids');

      return resolve(_this2.index.search({
        query: criteria,
        filters: options.map(function (o) {
          return field + ':' + o;
        }).toArray().join(' OR '),
        hitsPerPage: 500,
        page: 0
      }));
    });
  };

  algolia.prototype.merchantSlugSearch = function merchantSlugSearch(slug) {
    var _this3 = this;

    var params = toPairs(slug).map(function (p) {
      return [first(p) + ':' + last(p)];
    });

    return new Promise(function (resolve, reject) {
      return _this3.index.search({
        query: slug.slug
      }).then(function (res) {
        return res.hits.length > 0 ? resolve(res) : reject(res);
      });
    });
  };

  _createClass(algolia, [{
    key: 'index',
    set: function set(index) {
      this._index = this.client.initIndex(index);
      // sorts results by distance
      // requires https and a paid account
      //.setSettings({ ranking: ['typo', 'geo', 'words', 'attribute', 'proximity', 'exact', 'custom'] });
    },
    get: function get() {
      return this._index;
    }
  }]);

  return algolia;
}();


//////////////////
// WEBPACK FOOTER
// ../ui-utilities/es/algolia.js
// module id = 569
// module chunks = 4